import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=79a1f868&scoped=true&"
import script from "./LayoutBase.vue?vue&type=script&lang=ts&"
export * from "./LayoutBase.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=79a1f868&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a1f868",
  null
  
)

export default component.exports